module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "recently-on-forums"
    }
  }, [_c('h1', [_vm._v("Latest Forum Activity")]), _vm._v(" "), _c('div', {
    staticClass: "recent-forum-posts"
  }, _vm._l((_vm.recentForumPosts), function(forumPost) {
    return _c('div', {
      staticClass: "recent-forum-post"
    }, [_c('h2', [(forumPost.gameAlias) ? _c('router-link', {
      attrs: {
        "to": ("/Game/" + (forumPost.gameStringUrl) + "/Forums/" + (forumPost.categoryStringUrl) + "/" + (forumPost.forumStringUrl) + "/" + (forumPost.threadStringUrl))
      }
    }, [_c('i', {
      staticClass: "fas fa-gamepad"
    }), _vm._v(_vm._s(forumPost.gameAlias) + "\n                    "), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v("\n                    " + _vm._s(forumPost.threadAlias) + "\n                ")]) : _vm._e(), _vm._v(" "), (!forumPost.gameAlias) ? _c('router-link', {
      attrs: {
        "to": ("/Forums/" + (forumPost.categoryStringUrl) + "/" + (forumPost.forumStringUrl) + "/" + (forumPost.threadStringUrl))
      }
    }, [_vm._v("\n                    Devleteam Site Forums\n                    "), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v("\n                    " + _vm._s(forumPost.threadAlias) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "posted-by"
    }, [_c('i', {
      staticClass: "fa fa-comment-o"
    }), _vm._v("\n                Posted by "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (forumPost.posterStringUrl))
      }
    }, [_vm._v(_vm._s(forumPost.posterAlias))]), _vm._v(",\n                "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(forumPost.postDate)))])], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33b4e5c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/HomeDashboard/RecentlyOnForums.vue
// module id = 846
// module chunks = 2